import React, { Component } from 'react';
import jQuery from 'jquery';

import Core from './../../../Core/Core'
import ErrorManager from '../../../Core/ErrorManager';

import Header from './../../Header';
import Opinions from './../../Opinion/Opinions';
import OpinionForm from './../../Opinion/OpinionForm';
import ErrorBoundary from '../ErrorBoundary';

class OpinionsEdit extends Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            "client" : {},
            "opinions" : [], 
            "opinion" : { date: Math.round(new Date().getTime()/1000) },
        };

        this.load = this.load.bind(this);
        this.submit = this.submit.bind(this);
        this.handleRedux = this.handleRedux.bind(this);
        this.loadOpinion = this.loadOpinion.bind(this);

        this.load(props.match.params.id);
    }


    load(id)
    {
        Promise.all([
            Core.Instance.Request(Core.Address+"Client/"+id, null, "GET"),
            Core.Instance.Request(Core.Address+"Opinion/Client_id/"+id+";*?by=date&order=desc", null, "GET"),
            Core.Instance.Request(Core.Address+"Opinion/Client_id/*;"+id+"?by=date&order=desc", null, "GET"),
            Core.Instance.Request(Core.Address+"Opinion/Client_id/*;"+id+";*?by=date&order=desc", null, "GET"),
            Core.Instance.Request(Core.Address+"Opinion/Client_id/"+id+"?by=date&order=desc", null, "GET"),
        ])
        .then((data) => {
            if(data[0] == null)
            {
                ErrorManager.Instance.Handle("Aucun client ne possède cet identifiant.");
                return;
            }

            let opinions = data[1] != null ? data[1] : [];
            if(data[2] != null)
                opinions = opinions.concat(data[2]);
            if(data[3] != null)
                opinions = opinions.concat(data[3]);
            if(data[4] != null)
                opinions = opinions.concat(data[4]);
            opinions = opinions.sort((a,b) => {
                return parseInt(b.date) - parseInt(a.date)
            });
            this.setState({
                "client" : data[0],
                "opinions" : opinions 
            });
        });
    }

    loadOpinion(id)
    {
        Core.Instance.Request(Core.Address+"Opinion/"+id, null, "GET")
        .then((data) => {
            if(data == null)
            {
                ErrorManager.Instance.Handle("Aucun avis ne possède cet identifiant.");
                return;
            }

            jQuery('#addOpinionModal').modal('show');
            this.setState({
                "opinion" : data 
            });
        });
    }

    handleRedux(event)
    {
        let opinion = this.state.opinion;
        opinion[event.target.name] = event.target.value;
        this.setState({
            "opinion" : opinion
        });
    }

    submit()
    {
        if(Object.getOwnPropertyNames(this.state.opinion).length <= 0)
        {
            ErrorManager.Instance.Handle("Vous devez remplir le formulaire avant de pouvoir enregistrer.");
            return;
        }

        if(!Core.Instance.CheckForm(this))
            return;
        let opinion = this.state.opinion;
        //opinion.date = opinion.date != null ? opinion.date/1000 : null;
        opinion.Client_id = this.state.client.id;
        let request = null;

        if(opinion.id){
            request = Core.Instance.Request(Core.Address+"Opinion/"+opinion.id, opinion, "PUT");
        }else{
            request = Core.Instance.Request(Core.Address+"Opinion", opinion, "POST");
        }
        request.then((json) => {
            return Core.Instance.user.RegisterEdit(this.state.client.id, "Enregistrement d'un avis client.");
        }).then(() => {
            ErrorManager.Instance.Info("Les modifications ont bien été enregistrées.");
            window.location.reload();
        });      
    }

    render()
    {
        let name = this.state.client.first_name ? this.state.client.name + " " +this.state.client.first_name : this.state.client.name;
        document.title = "W-F: Avis liés "+name;

        return (
            <ErrorBoundary>
                <Header buttons={ [
                ] } />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col">
                            <div className="card m-3 p-3">
                                <div className="card-body">
                                    <div className="card-title">
                                        <span className="h4 align-middle">Avis associés au client</span>
                                        <span className="float-right" data-toggle="modal" data-target="#addOpinionModal">
                                            <a href="#"><li className='fas fa-plus'></li> <u>Ajouter un avis</u></a>    
                                        </span>
                                    </div>
                                </div>
                                <Opinions opinions={ this.state.opinions } editing={ true } loadOpinion={ this.loadOpinion }/>
                            </div>
                        </div>
                    </div>
                    <OpinionForm opinion={ this.state.opinion } onChange={ this.handleRedux } onSubmit={ this.submit }/>
                </div>
            </ErrorBoundary>
        );
    }
}
export default OpinionsEdit;



// WEBPACK FOOTER //
// ./src/Components/Views/Opinion/OpinionsEdit.js